module.exports = __webpack_public_path__ + "img/car1_2.0ab59478.png";